import { Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import { RED, HOVER_RED } from '../../Constants/cssColors'

export default withStyles({
  root: {
    backgroundColor: `${RED}`,
    color: 'white',
    '&:hover': {
      backgroundColor: `${HOVER_RED}`,
    },
  },
  outlinedPrimary: {
    borderColor: `${RED}`,
    color: `${RED}`,
    backgroundColor: 'transparent',
    '&:hover': {
      color: 'black',
      backgroundColor: `${HOVER_RED}`,
      borderColor: 'black',
    },
  },
})(Button)
